<template>
  <div class="certificateGetCertificate">
    <el-card v-if="checkAdmin()">
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="所属教务服务方" v-if="checkAdmin()">
          <el-select v-model="filter.companyId" placeholder="请选择所属项目">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="filter.auditState" placeholder="请选择审核状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="已驳回" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发货状态">
          <el-select v-model="filter.expressState" placeholder="请选择发货状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="未发送" value="1"></el-option>
            <el-option label="已发送" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card v-if="!checkAdmin()">
      <div class="box">
        <div class="item">
          当前标准班招生总数 &nbsp; | &nbsp; <span class="blue">{{ statisticsData.recruitNum || 0 }}</span><span class="small"> (单)</span>
        </div>
        <div class="item">
          当前实体证书申领总数 &nbsp; | &nbsp; <span class="blue">{{ statisticsData.applyNum || 0 }}</span><span class="small"> (本)</span>
        </div>
        <div class="item">
          当前实体证书使用总数 &nbsp; | &nbsp; <span class="blue">{{ statisticsData.useNum || 0 }}</span><span class="small"> (本)</span>
        </div>
      </div>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-button v-if="!checkAdmin()" type="primary" size="small" @click="judgeApply1">证书申领</el-button>
      <el-table :data="list" border style="margin-top: 10px">
        <el-table-column v-if="checkAdmin()" align="center" label="教务服务方" prop="companyName" width=""></el-table-column>
        <el-table-column align="center" label="申领日期" prop="applyTime" width="160"></el-table-column>
        <el-table-column align="center" label="累计招生" prop="cumulativeRecruit" width=""></el-table-column>
        <el-table-column align="center" label="累计已申领" prop="cumulativeApply" width=""></el-table-column>
        <el-table-column align="center" label="本次拟申领" prop="applyNum" width=""></el-table-column>
        <el-table-column align="center" label="申领人" prop="applyUserName" width=""></el-table-column>
        <el-table-column align="center" label="审核状态" prop="auditState" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.auditState === 1">待审核</span>
            <span v-if="scope.row.auditState === 2">已通过</span>
            <span v-if="scope.row.auditState === 3">已驳回</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="审核时间" prop="auditTime" width=""></el-table-column>
        <el-table-column align="center" label="审核人" prop="auditUserName" width=""></el-table-column>
        <el-table-column align="center" label="驳回原因" prop="rejectReason" width="">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" popper-class="tooltip" placement="top">
              <div slot="content" class="tooltip">{{ scope.row.rejectReason || '--' }}</div>
              <div style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;">{{ scope.row.rejectReason }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="发送状态" prop="expressState" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.expressState === 1">未发送</span>
            <span v-else-if="scope.row.expressState === 2">已发送</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="快递单号" prop="expressCode" width=""></el-table-column>
        <el-table-column align="center" label="操作" prop="" width="">
          <template slot-scope="scope">
            <a v-if="!checkAdmin() && scope.row.auditState === 1" href="javascript:;" @click="edit(scope.row)">编辑</a>
            <a v-if="checkAdmin() && scope.row.auditState === 1" href="javascript:;" @click="auditThis(scope.row)">审核</a>
            <a v-if="checkAdmin() && scope.row.auditState === 2" href="javascript:;" @click="updateState(scope.row)">修改发送状态</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog
      title="证书申领"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose">
      <p v-if="!audit" style="margin-bottom: 20px">当前申领上限为{{max}}本</p>
      <p v-if="audit" style="margin-bottom: 20px">当前申领上限预警数量{{max}}（本）</p>
      本次拟申领 <el-select v-model="applyNum" size="small" :disabled="audit">
        <el-option v-for="item in numList" :key="item" :value="item" :label="item"></el-option>
      </el-select>

      <template v-if="!audit">
        <p style="color: red; margin: 5px; margin-top: 30px">证书申领规则：</p>
        <p style="color: red; margin: 5px;">1.当前证书申领上限=当前教务服务方标准班招生总数-当前实体证书申领总数+补领证书总数+300</p>
        <p style="color: red; margin: 5px;">2.每次申领证书数量上限为2000</p>
      </template>
      <span v-if="!audit" slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="submit">提交申领</el-button>
      </span>
      <span v-if="audit" slot="footer" class="dialog-footer">
        <el-button size="small" type="danger" @click="$refs.AuditRejected.init()">审核驳回</el-button>
        <el-button size="small" type="primary" @click="auditApply(2)">审核通过</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改发送状态"
      :visible.sync="dialogVisible1"
      width="500px"
      :before-close="handleClose1">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="证书发送状态" prop="expressState">
          <el-radio-group v-model="ruleForm.expressState">
            <el-radio :label="1">未发送</el-radio>
            <el-radio :label="2">已发送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="快递单号" prop="expressCode">
          <el-input v-model="ruleForm.expressCode" maxlength="100" size="small" placeholder="请输入快递单号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose1">关 闭</el-button>
        <el-button size="small" type="primary" @click="updateExpressState">确 定</el-button>
      </span>
    </el-dialog>
    <AuditRejected ref="AuditRejected" @close="close" />
  </div>
</template>

<script>
import { getCompanyByPid, getStatisticsData, getListPageByAgent, getListPageApply, getApplyMaxNum, addCertificateApply, updateCertificateApply, auditApply, updateExpressState, judgeApply1 } from '@/api/certificate/index'
import AuditRejected from '../components/AuditRejected.vue'
export default {
  name: 'CertificateGetCertificate',
  components: { AuditRejected },
  data () {
    return {
      companyList: [],
      filter: {
        page: 1,
        limit: 10,
        companyId: '',
        auditState: '',
        expressState: ''
      },
      list: [],
      total: 0,
      dialogVisible: false,
      max: 0,
      numList: [],
      applyNum: '',
      row: null,
      statisticsData: {
        applyNum: 0,
        recruitNum: 0,
        useNum: 0
      },
      audit: false,
      // 驳回原因
      rejectReason: '',
      dialogVisible1: false,
      ruleForm: {
        expressState: '',
        expressCode: ''
      },
      rules: {
        expressState: [{ required: true, message: '请选择证书发送状态', trigger: 'change' }]
      }
    }
  },
  created() {
    if (this.checkAdmin()) {
      this.getCompanyByPid()
    } else {
      this.getStatisticsData()
    }
    this.getList()
  },
  methods: {
    async getCompanyByPid() {
      const res = await getCompanyByPid({id: 1})
      this.companyList = res.data
    },
    async getStatisticsData () {
      const res = await getStatisticsData()
      this.statisticsData = res.data
    },
    async getList() {
      let res
      if (this.checkAdmin()) {
        res = await getListPageApply(this.filter)
      } else {
        res = await getListPageByAgent(this.filter)
      }
      this.list = res.data.records
      this.total = +res.data.total
    },
    async judgeApply1 () {
      const res = await judgeApply1()
      if (res.code === 1000) {
        return this.$message.error('当前已有证书套打申请待审核。')
      }
      this.getApplyMaxNum()
    },
    async getApplyMaxNum () {
      const res = await getApplyMaxNum()
      this.max = res.data.max
      this.numList = res.data.list
      this.dialogVisible = true
    },
    // 提交 新增 / 编辑
    async submit(formName) {
      if (!this.applyNum) {
        return this.$message.error('请选择要申领的数量')
      }
      const sendObj = {applyNum: this.applyNum,maxNum: this.max}
      let res
      if (this.row) {
        // 编辑
        sendObj.id = this.row.id
        res = await updateCertificateApply(sendObj)
      } else {
        // 新增
        res = await addCertificateApply(sendObj)
      }
      if (res.code !== 0) return this.$message.error(res.message)
      this.$message.success('操作成功!')
      this.handleClose()
      this.getList()
    },
    async auditApply (auditState) {
      const res = await auditApply({ id: this.row.id, auditState, rejectReason: this.rejectReason })
      this.$message.success('操作成功')
      this.handleClose()
      this.getList()
    },
    async updateExpressState () {
      this.$refs['ruleForm'].validate(async(valid) => {
        if (valid) {
          const res = await updateExpressState({...this.ruleForm, id: this.row.id})
          this.$message.success('操作成功')
          this.handleClose1()
          this.getList()
        } else {
          this.$message.warning('请完善内容后继续操作')
        }
      })
    },
    updateState(row) {
      this.row = row
      Object.keys(this.ruleForm).forEach(key => {
        this.ruleForm[key] = row[key]
      })
      this.dialogVisible1 = true
    },
    handleClose1() {
      this.dialogVisible1 = false
      this.row = null
      Object.keys(this.ruleForm).forEach(key => {
        this.ruleForm[key] = ''
      })
    },
    close(rejectReason) {
      this.rejectReason = rejectReason
      this.auditApply(3)
    },
    auditThis(row) {
      this.audit = true
      this.row = row
      this.applyNum = row.applyNum
      this.max = row.maxNum
      this.dialogVisible = true
    },
    edit(row) {
      this.row = row
      this.applyNum = row.applyNum
      this.getApplyMaxNum()
    },
    handleClose() {
      this.dialogVisible = false
      this.max = 0
      this.numList = []
      this.applyNum = ''
      this.row = null
      this.audit = false
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = ''
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.certificateGetCertificate {
  .box {
    display: flex;
    .item {
      flex: 1;
      font-size: 24px;
      text-align: center;
      .blue {
        color: blue;
      }
      .small {
        font-size: 14px;
      }
    }
  }
}

.tooltip {
  width: 500px !important;
}
</style>
